<template>
  <div class="journal-page">
    <div class="section-header">
      <i v-if="xs && menu === false" class="material-icons clickable" @click="menu=true">menu</i>
      <i v-if="xs && menu === true" class="material-icons clickable" @click="menu=false">close</i>
      <h1>Journal</h1>
      <i class="material-icons clickable" @click="setEntry({})">add</i>
    </div>

    <div class="journal row">
      <div class="previous-entries" v-if="menu || !xs">
        <div class="search">
          <i class="material-icons" v-if="!xs">
            search
          </i>
          <input v-model="search" @keyup="beginSearch" class="full-width" type="text" placeholder="Search..." /> 
        </div>
        <div
          v-infinite-scroll="more"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="15"
          >
        <previous-entry 
          v-for="(entry, i) in entries" 
          :key="i" :entry="entry" 
          @selected="setEntry(entry)"
          class="clickable" />
        </div>
        <div v-if="loading" class="small-top">Loading...</div>
      </div>
      <form class="entry" @submit.prevent="save" v-if="!menu || !xs">
        <input
          class="full-width"
          placeholder="Title..."
          v-model="selectedEntry.title" 
          required
          />
        <div class="divider" />
        <textarea 
          v-model="selectedEntry.text" 
          class="full-width" 
          placeholder="Write something..."
          @keyup="saveDraft"
          required
          />
        <button class="btn btn--full save-btn">Save</button>
      </form>
    </div>
  </div>
</template>

<script>
import previousEntry from "./previousEntry";
import Paginator from "@/services/api/paginator";
const CLIENT_NOTE_STORE = "ClientNotes";
import snackbar from "@/services/hubs/snackbar";
import store from "@/services/api/store";
import rafflehub from "@/services/hubs/raffle";

export default {
  components: { previousEntry },
  data() {
    return {
      selectedEntry: {},
      entries: [],
      busy: false,
      loading: true,
      search: "",
      menu: false,
      xs: window.innerWidth <= 600
    };
  },
  created() {
    this.paginator = new Paginator(CLIENT_NOTE_STORE, {}, 15);
    this.more();
  },
  methods: {
    beginSearch() {
      clearTimeout(this.timeout);
      this.entries = [];
      this.loading = true;
      this.timeout = setTimeout(() => {
        this.paginator = new Paginator(CLIENT_NOTE_STORE, {search: this.search}, 15);
        this.error = "";
        this.more();
      }, 600);
    },
    setEntry(entry) {
      this.selectedEntry = entry;
      this.menu = false;
    },
    saveDraft() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.save(false);
        snackbar.update("Saving draft");
      }, 1000);
    },
    save(showSave=true) {
      if (showSave) {
        snackbar.update("Saved");
        rafflehub.update('journal');
      }
      if (this.selectedEntry.id) {
        store.update(CLIENT_NOTE_STORE, this.selectedEntry.id, this.selectedEntry);
      } else {
        store.create(CLIENT_NOTE_STORE, this.selectedEntry)
        this.entries = [this.selectedEntry, ...this.entries];
      }
    },
    more() {
      if (this.paginator.finished || this.error) {
        return;
      }
      this.busy = true;
      this.loading = true;
      return this.paginator
        .next()
        .then(entries => {
          this.entries = [...this.entries, ...entries];
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.busy = false;
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../styles/screenSizes";
.journal-page {

  .journal {
    border-radius: 20px;
    width: 100%;
    height: 65vh;
    color: black;
    background: rgba(231,231,231,.8);
    line-height: 25px;
    font-size: 18px;

    font-family: Avenir-Book;
    font-size: 18px;
    color: black;
    letter-spacing: 0;

    .search {
      display: flex;
      flex-direction: row;
      /* justify-content: center; */
      align-items: flex-end;
      justify-content: flex-end;

      i {
        padding: 5px;
      }
    }

    .previous-entries {
      // brackground-op
      background: rgba(0, 0, 0, 0.4);
      border-bottom-left-radius: 20px;
      border-top-left-radius: 20px;
      color: white;
      height: 100%;
      max-height: 100%;
      overflow-y: auto;
      padding: 1em;
      width: 400px;
      max-width: 30%;

      font-size: 15px;
      color: #FFFFFF;
      letter-spacing: 0;

    }

    .entry {
      padding: 1em;
      width: 100%;
      position: relative;
      button {
        position: absolute;
        bottom: 5px;
        left: 5px;
        width: calc(~'100% - 12px');
      }

      textarea {
        height: 75%;
      }

      .divider {
        border-bottom-color: darkgray;
      }
    }
  }

  @media (max-width: @xs) {
    .journal {
      .previous-entries {
        max-width: 100% !important;
        width: 100%;
        background: gray;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        .search {
          margin-top: 2em;
          min-width: 100%;
        }
      }
    }
  }
}
</style>
